import type { LngLatLike } from 'mapbox-gl';
import { User } from '~/users/types';

export enum RiskStateEnum {
  RED = 'RED',
  YELLOW = 'YELLOW',
  GREEN = 'GREEN',
  GREY = 'GREY',
}

export enum StatusColorEnum {
  GREY = 'grey',
  GREEN = 'green',
  YELLOW = 'yellow',
  RED = 'red',
}

export enum LocationTypeEnum {
  LOGIN = 'login',
  LOGOUT = 'logout',
  CHECK_IN = 'check-in',
  SOS = 'sos',
  LOCATION_UPDATE = 'location-update',
  MISSED_CHECK_IN = 'missed-check-in',
}

export enum LocationSourceEnum {
  GARMIN = 'Garmin',
  JOURNEY = 'Journey',
  LONE_WORKER = 'LoneWorker',
}

export interface Location {
  id: string;
  userID: User['userID'];
  gpsLocation: string | LngLatLike | null;
  status: string;
  time: string; // ISO-8601 duration (e.g., "PT1H20M") or "0"
  type: string;
  notes: string;
  source: string;
  created_at: string; // ISO-8601 datetime
  lastSeenDate?: string;
  user?: { data: User };
}
